webpackJsonp([35783957827783],{

/***/ 84:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logo.7336fb12.svg";

/***/ }),

/***/ 390:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n\t\theight: 30px;\n\t"], ["\n\t\theight: 30px;\n\t"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(26);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _lodash = __webpack_require__(23);
	
	var _gatsbyPluginPageTransitions = __webpack_require__(89);
	
	var _gatsbyPluginPageTransitions2 = _interopRequireDefault(_gatsbyPluginPageTransitions);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _components = __webpack_require__(11);
	
	var _settings = __webpack_require__(27);
	
	var _utils = __webpack_require__(86);
	
	var _themes = __webpack_require__(15);
	
	var _global = __webpack_require__(6);
	
	var _logo = __webpack_require__(84);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _utils2 = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Home = function (_Component) {
		_inherits(Home, _Component);
	
		function Home() {
			var _temp, _this, _ret;
	
			_classCallCheck(this, Home);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
				sections: []
			}, _this.componentWillMount = function () {
				_this.props.fetchSettings();
			}, _this.componentDidMount = function () {
				var settings = _this.props.settings;
	
				var data = _this.props.data.wordpressHome;
	
				_this.setState({
					sections: JSON.parse(data.acf_json).sections,
					pageLoaded: true
				});
			}, _this.renderBlocks = function (blocks) {
				return blocks.map(function (block, i) {
					return _react2.default.createElement(_components.Block, _extends({
						layout: block.acf_fc_layout,
						key: i
					}, block));
				});
			}, _this.renderSections = function () {
				var sections = _this.state.sections;
	
	
				return sections.map(function (section, i) {
					var blocks = section.blocks;
	
					if (section.display_section && section.blocks) {
						return _react2.default.createElement(_components.Section, {
							key: i,
							blocks: blocks,
							section: section
						});
					}
				});
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		Home.prototype.render = function render() {
			var pageLoaded = this.state.pageLoaded;
	
			var splashActive = this.props.settings.splashActive;
	
			return _react2.default.createElement(
				_react2.default.Fragment,
				null,
				_react2.default.createElement(
					_gatsbyPluginPageTransitions2.default,
					_utils.pageTransitionProps,
					_react2.default.createElement(
						Wrapper,
						{
							active: splashActive == false
						},
						this.renderSections()
					)
				)
			);
		};
	
		return Home;
	}(_react.Component);
	
	var Wrapper = _styledComponents2.default.div.withConfig({
		displayName: "pages__Wrapper",
		componentId: "k5b7gm-0"
	})(["display:flex;flex-direction:column;align-items:center;width:100%;z-index:2;transition:all 0.75s ease;transition-delay:0.4s;will-change:transform;transform:translateY(100px);opacity:0;", ""], function (props) {
		if (props.active) return (0, _styledComponents.css)(["transform:translateY(0);opacity:1;"]);
	});
	
	var Container = _styledComponents2.default.div.withConfig({
		displayName: "pages__Container",
		componentId: "k5b7gm-1"
	})(["", " display:flex;flex-direction:column;"], _global.container);
	
	// Shared
	
	var Heading = _styledComponents2.default.div.withConfig({
		displayName: "pages__Heading",
		componentId: "k5b7gm-2"
	})(["", ""], _global.heading);
	var Description = _styledComponents2.default.div.withConfig({
		displayName: "pages__Description",
		componentId: "k5b7gm-3"
	})([""]);
	
	// Hero
	
	var Splash = _styledComponents2.default.div.withConfig({
		displayName: "pages__Splash",
		componentId: "k5b7gm-4"
	})(["position:fixed;top:0;left:0;right:0;bottom:0;background:rgb(228,231,235);z-index:13;display:flex;justify-content:center;", "{height:100%;justify-content:center;align-items:center;}opacity:0;pointer-events:none;transition:opacity 0.75s ease-out;", " ", ""], Container, function (props) {
		if (props.active) return (0, _styledComponents.css)(["opacity:1;pointer-events:all;"]);
	}, function (props) {
		if (props.theme) {
			var theme = _themes.themes[props.theme];
			return (0, _styledComponents.css)(["background:", ";", "{color:", "}"], theme.background, Heading, theme.text);
		}
	});
	
	var Logo = _styledComponents2.default.div.withConfig({
		displayName: "pages__Logo",
		componentId: "k5b7gm-5"
	})(["background-image:url(", ");width:374px;height:40px;", " ", ""], _logo2.default, _global.bgIcon, _utils2.media.tablet(_templateObject));
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
		return {
			fetchSettings: function fetchSettings() {
				dispatch((0, _settings.fetchSettings)());
			},
			updateSettings: function (_updateSettings) {
				function updateSettings(_x) {
					return _updateSettings.apply(this, arguments);
				}
	
				updateSettings.toString = function () {
					return _updateSettings.toString();
				};
	
				return updateSettings;
			}(function (setting) {
				dispatch(updateSettings(setting));
			})
		};
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
		return {
			settings: state.settings.settings
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Home);
	
	// Set here the ID of the home page.
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-4a8974f88f088cfd9f08.js